<template src="./HabileSignIn.html"/>
<style lang="scss" scoped src="./HabileSignIn.scss"/>

<script>

import {
    SfBreadcrumbs,
    SfNotification,
    SfLoader
} from '@storefront-ui/vue';
import Api from "@/api/Api";
import OrkLoader from "@/components/Ork/OrkLoader";


export default {
    name: 'HabileSignIn',
    transition: 'fade',
    components: {
        SfLoader,
        OrkLoader,
        SfNotification,
        SfBreadcrumbs
    },
    data() {
        return {
            errormessage: '',
            loading: true,
            error: null,
            breadcrumbs: [
                {
                    text: this.$i18n.t('Home'),
                    link: '/'
                },
                {
                    text: this.$i18n.t('Habile sign-in'),
                }
            ]
        };
    },
    mounted() {
        this.loading = true;
        this.getHabileAuth()
    },
    methods: {
        getHabileAuth() {
            this.loading = true;
            const authorizationCode = this.$router.history.current.query.code;
            //  console.log('code', authorizationCode)
            if (authorizationCode) {
                Api.account.loginHabile(authorizationCode).then((data) => {
                    this.$store.dispatch('loginCustomer', data);
                    this.$store.dispatch('getCategoryTree');
                    if (sessionStorage.getItem("configureEmpowerment")) {
                        sessionStorage.removeItem("configureEmpowerment")
                        this.$router.push(this.$localizePath("/configure-empowerment")).catch();
                    } else {
                        this.$store.dispatch('toggleWelcomeModal', {
                            open: true,
                            customer: data
                        });
                        this.$router.push(this.$localizePath("/")).catch();
                    }
                }).catch((e) => {
                    if (e.status) {
                        switch (e.status) {
                            case 404:
                                this.errormessage = this.$i18n.t('errors.habile.notfound')
                                break
                            case 502:
                                this.errormessage = this.$i18n.t('errors.habile.error')
                                break
                            default:
                                this.errormessage = 'something wrong append: unsupported status : ' + e.status
                                break
                        }
                    }
                    this.error = true;
                    this.loading = false
                }).finally(

                )
            } else {
                this.error = true;
                this.errormessage = this.$i18n.t('errors.habile.error')
                this.loading = false
            }
        }
    }
};
</script>
